export const animation = {
  maskShowDuration: 0.5,
  maskHideDuration: 1,
  lineDuration: 0.06,
  wordDuration: 0.007,
  charDuration: 0.005,
  headingLineDuration: 0.07,
}
